<template>
  <div class="pl-3 sm:px-5 navContainer" :class="{ 'scrolled': !view.atTopOfPage }" style="top:0">

    <nav class="m-auto flex items-center justify-between" style="height:75px">

      <img
        v-if="user"
        class="p-1 icon opacity-75 md:hidden"
        src="@/assets/office-icons/nav-alt.svg"
        alt="open side drawer"
        width=40
        @click="$eventHub.$emit('open-sideDrawer')"
      >

      <div class="hidden md:flex items-center">
        <router-link 
          :to="{path: `/`}" >
          <img src="@/assets/logo.png" alt="reserve a desk logo" style="height:40px">
        </router-link>
      </div>
      <div class="ml-auto p-3">
        <!-- <li class="">
          <router-link 
            v-if="user"
            :to="{path: `/s/account`}" 
            class="animated"
            :class="{active: $route.name==='Account'}">
            <img src="@/assets/office-icons/user-tie.svg" alt="Account" style="width:30px">
          </router-link>
        </li> -->
        <div class="group inline-block relative"
          v-if="user"
          @mouseover="view.userDropdown=true"
          @mouseleave="view.userDropdown=false">
          <span
            class="py-2 px-4 inline-flex items-center cursor-pointer">
            <img
              class="p-1 icon opacity-75"
              src="@/assets/gamer-life-icons/user-circle.svg"
              :alt="$t('main-nav-Settings')"
              width=40
            >
          </span>
          <ul class="absolute z-50 bg-secondary w-48 rounded shadow-lg dropdown" v-if="view.userDropdown">
            <li>
              <router-link 
                :to="{path: `/s/account`}" 
                class="animated">
                <img
                  class="icon"
                  width=20
                  src="@/assets/office-icons/settings.svg"
                  :alt="$t('main-nav-Account')"
                >
                {{$t('main-nav-Account')}}
              </router-link>
            </li>
            <li>
              <themeToggle></themeToggle>
            </li>
          </ul>
        </div>
        <router-link 
          v-if="!user"
          :to="{path: `/login`}" 
          class="animated"
          :class="{active: $route.name==='Login'}">
          Log In
        </router-link>
      </div>
    </nav>

</div>
</template>

<script>

import themeToggle from "@/components/themeToggle"

export default {
  name: 'HeaderNav',
  components: {
    themeToggle
  },
  props: {
    msg: String
  },
  data: function () {
    return {
      view: {
        userDropdown: false,
        atTopOfPage: true,
        showNav: false
      }
    }
  },
  // a beforeMount call to add a listener to the window
  beforeMount () {
    // window.addEventListener('scroll', this.handleScroll);
  },
  computed: {
    user () {
      return this.$store.getters.userData
    },
    org () {
      return this.$store.getters.activeOrg
    }
  },
  watch:{
      $route (){
        this.view.showNav = false
      }
  }, 
  mounted: function() {


  },
  methods: {
    subscribeUser(email){
      let obj = {
        "email": email
       }
      fetch('/api/subscribe/mailchimp', {
          method: 'post',
          body: JSON.stringify(obj),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(response=>{
          return response.json();
        })
        .then(data=>{
          // console.log("user subscribed data:", data)
          if(data.error){
            throw data.error
          } else {
            // user subscribed successfully
          }
        })
        .catch(()=>{
          // console.log("err subscribing user:", err);
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >

  .navContainer {
    z-index: 30
  }

  .dropdown {
    right: 8px;
  }
  .dropdown li > * {
    @apply p-3 flex items-center;
  }

  .dropdown li > *:hover {
    @apply bg-opacity-75;  
    background-color: var(--bg-primary)
  }

  .dropdown li a img {
    @apply mr-2;
  }
</style>
